export enum ProcedureType {
    Maintenance = 'Maintenance',
    Plastics = 'Plastics',
    Automation = 'Automation',
    Metals = 'Metals',
}